module.exports = __webpack_public_path__ + "img/calligraphy-work-icon7.84bf359d.jpg";